import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Media } from '../../theme/Media';
const Wrapper = styled.div `
  position: relative;
  @media ${Media.smMin} {
    flex: 0 0 220px;
  }
`;
const Select = ({ children, dataTestId }) => _jsx(Wrapper, { "data-testid": dataTestId, children: children });
export default Select;
